export interface AdjustmentReason {
  id: number;
  name: string;
  description: string;
  requires_location: boolean; // Si requiere ubicación de destino
  is_reduction: boolean; // Si es una rebaja (saca del sistema)
  is_active: boolean;
}

export const ADJUSTMENT_REASONS: AdjustmentReason[] = [
  {
    id: 1,
    name: 'Mal Ingresado',
    description: 'Producto ingresado con cantidad incorrecta',
    requires_location: false,
    is_reduction: true,
    is_active: true,
  },
  {
    id: 2,
    name: 'Mermado',
    description: 'Producto dañado o deteriorado',
    requires_location: false,
    is_reduction: true,
    is_active: true,
  },
  {
    id: 3,
    name: 'Vencido',
    description: 'Producto vencido o caducado',
    requires_location: true,
    is_reduction: true,
    is_active: true,
  },
  {
    id: 4,
    name: 'Basura',
    description: 'Producto inservible para venta',
    requires_location: false,
    is_reduction: true,
    is_active: true,
  },
  {
    id: 5,
    name: 'Robado',
    description: 'Producto robado o extraviado',
    requires_location: false,
    is_reduction: true,
    is_active: true,
  },
  {
    id: 6,
    name: 'Cambio de Ubicación',
    description: 'Movimiento normal de inventario',
    requires_location: true,
    is_reduction: false,
    is_active: true,
  },
  {
    id: 7,
    name: 'Cambio de Contenedor',
    description: 'Cambio de contenedor de origen',
    requires_location: false,
    is_reduction: false,
    is_active: true,
  },
];
